import React, { Component, useState, useEffect } from 'react';
import logo from './logo.svg';
import Inicio from '../src/bigboxs/Inicio/Inicio';
import Obras from '../src/bigboxs/Obras/Obras';
import Fim from '../src/bigboxs/Fim/Fim';
import $, { when } from "jquery";
import { debounce, throttle } from 'lodash';
import ativo1 from '../src/assets/svgs/translate.svg';


class App extends Component {
  componentDidMount() {



    if(window.matchMedia("(max-width: 600px)").matches){

    }
    else{
      if($( ".magazinenova" ).mousemove=true){
        $( ".magazinenova" ).mousemove(function( event ) {
          
          $("#desapa").fadeIn();
    
          
        });
      }
      else{
        $("#desapa").fadeOut();

      }

    }



    $("#dimensao").click(function()
    
    {
      console.log("aiai");
      $("#video").prop('muted', false);
      $("#dimensao").addClass("todonone");
      $("#dimensao2").removeClass("todonone");
      $("#desapa2").addClass("todonone");
      $("#video").addClass("pulo");

      $("#TO7dimensao").removeClass("todonone");
      $("#TO7desapa2").removeClass("todonone");
      $("#TO7obra1").removeClass("pulo");
      $("#TO7obra1").removeClass("pulo");
      $("#TO7video").removeClass("pulo");
      $("#TO7local1").removeClass("pulo");
      $("#TO7video").prop('muted', true);

      $("#TO6dimensao").removeClass("todonone");
      $("#TO6desapa2").removeClass("todonone");
      $("#TO6obra1").removeClass("pulo");
      $("#TO6obra1").removeClass("pulo");
      $("#TO6video").removeClass("pulo");
      $("#TO6local1").removeClass("pulo");
      $("#TO6video").prop('muted', true);

      $("#TO5dimensao").removeClass("todonone");
      $("#TO5desapa2").removeClass("todonone");
      $("#TO5obra1").removeClass("pulo");
      $("#TO5obra1").removeClass("pulo");
      $("#TO5video").removeClass("pulo");
      $("#TO5local1").removeClass("pulo");
      $("#TO5video").prop('muted', true);

      $("#TO4dimensao").removeClass("todonone");
      $("#TO4desapa2").removeClass("todonone");
      $("#TO4obra1").removeClass("pulo");
      $("#TO4obra1").removeClass("pulo");
      $("#TO4video").removeClass("pulo");
      $("#TO4local1").removeClass("pulo");
      $("#TO4video").prop('muted', true);

      $("#TO3dimensao").removeClass("todonone");
      $("#TO3desapa2").removeClass("todonone");
      $("#TO3obra1").removeClass("pulo");
      $("#TO3obra1").removeClass("pulo");
      $("#TO3video").removeClass("pulo");
      $("#TO3local1").removeClass("pulo");
      $("#TO3video").prop('muted', true);

      $("#TO2dimensao").removeClass("todonone");
      $("#TO2desapa2").removeClass("todonone");
      $("#TO2obra1").removeClass("pulo");
      $("#TO2obra1").removeClass("pulo");
      $("#TO2video").removeClass("pulo");
      $("#TO2local1").removeClass("pulo");
      $("#TO2video").prop('muted', true);

      $("#TO8dimensao").removeClass("todonone");
      $("#TO8desapa2").removeClass("todonone");
      $("#TO8obra1").removeClass("pulo");
      $("#TO8obra1").removeClass("pulo");
      $("#TO8video").removeClass("pulo");
      $("#TO8local1").removeClass("pulo");
      $("#TO8video").prop('muted', true);
  

    }
    );
    $("#dimensao2").click(function()
    
    {
     
      $("#video").prop('muted', true);
      $("#dimensao2").addClass("todonone");
      $("#dimensao").removeClass("todonone");
      $("#desapa2").removeClass("todonone");
      $("#obra1").removeClass("pulo");
      $("#obra1").removeClass("pulo");
      $("#video").removeClass("pulo");
      $("#local1").removeClass("pulo");
    }
    );


    $("#magazinenova").click(function(){
      $("#desapa").delay('slow').fadeIn();
        
    

      setTimeout(
        function() 
        {

          
          var desaparecendo = 'todonone';
          
          $("#desapa").fadeOut();
        }, 30000);

    });

    (function () {

      $("#botomenu").click(function () {
        $( this ).slideUp().fadeOut(10000);
        $("#hold1 ").addClass("cc");
        $("#botoobras ").addClass("cc");
        $("#hold3 ").addClass("cc");
        $("#hold4 ").addClass("cc");
        $("#hold5 ").addClass("cc");
        $("#hold1 ").removeClass("transiopaca");
        $("#botoobras ").removeClass("transiopaca");
        $("#hold3 ").removeClass("transiopaca");
        $("#hold4 ").removeClass("transiopaca");
        $("#hold5 ").removeClass("transiopaca");
        setTimeout(function(){
          setTimeout(function(){
            $("#hold5 ").addClass("transiopaca");
            setTimeout(function(){
              $("#hold4 ").addClass("transiopaca");
              setTimeout(function(){
                $("#hold3 ").addClass("transiopaca");
                setTimeout(function(){
                  $("#botoobras ").addClass("transiopaca");
                  $("#hold1 ").addClass("transiopaca");
                  setTimeout(function(){
                    $("#hold1 ").removeClass("cc");
                    $("#botoobras ").removeClass("cc");
                    $("#hold3 ").removeClass("cc");
                    $("#hold4 ").removeClass("cc");
                    $("#hold5 ").removeClass("cc");
                    $("#botomenu").slideDown();
                  },1000);
                },1000);


              },1000);


            },1000);

          },1000);







          }, 3000);
        console.log("pé");
      });

      var qua = $('.resposta');
      var $target = $('.gatilhoObra'),
        animationClass = 'respostaGatilho',
        animationClass2 = 'respostaGatilho2',
        offset = $(window).height() * 1 / 10;



      function animeScroll() {
        $("#desapa").fadeOut();
        
    

        setTimeout(
          function() 
          {
            var desaparecendo = 'todonone';
          
            $("#desapa").fadeIn();
          }, 2000);


        var documentTop = $(document).scrollTop();

        $target.each(function (index) {

          var itemTop = $(this).offset().top;

          if (documentTop > itemTop - offset) {
            $("#botoobras").addClass(animationClass2);
            
          }
          else{
            $("#boto" + index).removeClass(animationClass);
              
          }

          if (documentTop > itemTop - offset) {
            $("#boto" + index).addClass(animationClass);
            
            if (documentTop > itemTop * 2 - offset * 2) {
              $("#boto" + index).removeClass(animationClass);
              
            }
            if (documentTop > itemTop){
              $("#boto" + index).removeClass(animationClass);
              
            }
          }
          if (documentTop > itemTop *4){
            
    
              $("#aaaa").click(function(){
                  $("#aquiemcima").addClass("eleexiste");
                
      
              });



            
          }
        }

        

        );
      }

     

      $(document).scroll(debounce(function () {
        animeScroll();
      }, 200));
    })();


    $('.bolinhas a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      var id = $(this).attr('href'),
        targetOffset = $(id).offset().top;

      $('html, body').animate({
        scrollTop: targetOffset - 0
      }, 500);
    });


    $('.grandeMenu a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      var id = $(this).attr('href'),
        targetOffset = $(id).offset().top;

      $('html, body').animate({
        scrollTop: targetOffset - 0
      }, 500);
    });
  }
  render() {
    return (
      <section>
        <div id="clicktela" className="menufixado">
          <div className="bolinhas">
            <a id="boto0" href="#obra1" className="resposta"> </a>
            <a id="boto1" href="#TO2obra1" className="resposta"></a>
            <a id="boto2" href="#TO3obra1" className="resposta"></a>
            <a id="boto3" href="#TO4obra1" className="resposta"></a>
            <a id="boto4" href="#TO5obra1"className="resposta"> </a>
            <a id="boto5" href="#TO6obra1"className="resposta"></a>
            <a id="boto6" href="#TO7obra1"className="resposta">></a>
            <a id="boto7" href="#TO8obra1"className="resposta">></a>
          </div>
          <div id="grandeMenu" className="grandeMenu">
          <a id ="botomenu"> <img className="espe" src={ativo1} alt=""/></a>
    
          <a  className="aa resposta" id="hold1" href="">Français  </a>
          <a id ="hold4" className="aa" href="https://10dimensoes.com/10anos/esp">Espagnol </a>
          <a id ="hold3" className="aa" href="https://10dimensoes.com/10anos/ptbr">Portugais</a>
          <a id ="hold4" className="aa" href="https://10dimensoes.com/10anos/eng">Anglais</a>
       
          </div>
        </div>
        <Inicio />
        <Obras />
        <Fim />
      </section>
    );
  }
}

export default App;
